import { useEffect, useRef } from 'react';
import { DroneEntity } from '@src/core/features';

/**
 * Hook to automatically close overlays when selected drone changes
 * @param selectedDrone - Currently selected drone
 * @param position - Current position overlay state (if null, overlay is closed)
 * @param removePosition - Function to close the position overlay
 * @param clickedDrone - Current clicked drone for DroneInfoOverlay
 * @param setClickedDrone - Function to close the DroneInfoOverlay
 */
export const useCloseOverlayOnDroneChange = (
  selectedDrone: DroneEntity | null,
  position: google.maps.LatLngLiteral | null,
  removePosition: (() => void) | undefined,
  clickedDrone: DroneEntity | null,
  setClickedDrone: ((drone: DroneEntity | null) => void) | undefined
): void => {
  const prevSelectedIdRef = useRef<number | undefined>(undefined);

  useEffect(() => {
    const currentId = selectedDrone?.id;

    // Close PositionOverlay if drone changed (not on initial selection)
    if (
      prevSelectedIdRef.current !== undefined &&
      prevSelectedIdRef.current !== currentId &&
      position
    ) {
      removePosition?.();
    }

    // Close DroneInfoOverlay whenever a drone is selected (from sections or overlay)
    if (selectedDrone && clickedDrone) {
      setClickedDrone?.(null);
    }

    prevSelectedIdRef.current = currentId;
  }, [selectedDrone, position, removePosition, clickedDrone, setClickedDrone]);
};

